module.exports = __webpack_public_path__ + "img/cases-brand-herborist-4.5a212bde.jpg";